import React, { useState } from "react";
import { FaX } from "react-icons/fa6";
import FullScreenMap from "components/FullscreenMap";
import LocationSetter from "components/LocationSetter";
import DeviceList from "components/DeviceList";
import InfoButton from "components/InfoButton";
import Login from "pages/Login";
import DeviceMarker from "./DeviceMarker";
import Footer from "./Footer";
import {
  TermsOfUseModal,
  PrivacyPolicyModal,
  PolicyButtons,
} from "./PolicyModals";
import logo from "assets/Overwatch_App_Logo_By_RescAlert_TM_white.png";
import logoDark from "assets/Overwatch_App_Logo_By_RescAlert_TM.png";

const DesktopView = ({
  // App Context
  appContext,

  // Auth & Login
  loginTrigger,

  // Device List Panel
  showMobileDevices,
  setShowMobileDevices,
  showSettingsState,
  setShowSettingsState,
  discardChanges,

  // Device List Props
  groupedDevices,
  toggleCategoryCollapse,
  collapsedCategories,
  toggleGroupCollapse,
  collapsedGroups,
  listSelect,
  setListSelect,
  setMapCenter,
  setMapZoom,
  getBasicDeviceIcon,
  selectedDevices,
  toggleDevice,
  setLoginPopupOpen,
  triggerLoginOpen,
  handleSave,

  // Map related
  _initialMapCenter,
  _initialMapZoom,
  mapCenter,
  mapZoom,
  setCalcZoom,
  setCalcCenter,
  displayData,
  calcZoom,
  deviceTypeToCategory,
  popupOpen,
  setPopupOpen,
  saveSuccess,

  // Modal related
  showTermsOfUse,
  setShowTermsOfUse,
  showPrivacyPolicy,
  setShowPrivacyPolicy,

  // Exploded groups
  explodedGroups,
  setExplodedGroups,
  toggleGroupExploded,
  calculateBounds,
  setMultipleGroupsCollapse,
}) => {
  const [filter, setFilter] = useState("");
  const [shouldResetFilter, setShouldResetFilter] = useState(false);

  const [selectedGroup, setSelectedGroup] = useState(null);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: 20,
      }}
    >
      {/* Device list panel */}
      {showMobileDevices && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            position: "absolute",
            top: 150,
            right: 20,
            maxHeight: "70vh",
            height: "70vh",
            overflow: "auto",
            width: 500,
            background: "#1e374f",
            zIndex: 1,
            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
          }}
        >
          <div
            style={{
              width: "500px",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
            }}
          >
            <div style={{ padding: "15px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 18,
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    color: "white",
                  }}
                >
                  {showSettingsState ? "Device Subscriptions" : "Device List"}
                </div>
                <div
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                    marginRight: 15,
                  }}
                  onMouseDown={() => {
                    setShowMobileDevices(false);
                    discardChanges();
                    setShowSettingsState(false);
                  }}
                >
                  <FaX size={20} color={"white"} />
                </div>
              </div>
              <DeviceList
                showSettingsState={showSettingsState}
                setShowSettingsState={setShowSettingsState}
                setLoginPopupOpen={setLoginPopupOpen}
                triggerLoginOpen={triggerLoginOpen}
                handleSave={handleSave}
                saveSuccess={saveSuccess}
                groupedDevices={groupedDevices}
                toggleCategoryCollapse={toggleCategoryCollapse}
                collapsedCategories={collapsedCategories}
                toggleGroupCollapse={toggleGroupCollapse}
                collapsedGroups={collapsedGroups}
                listSelect={listSelect}
                setListSelect={setListSelect}
                setMapCenter={setMapCenter}
                setMapZoom={setMapZoom}
                getBasicDeviceIcon={getBasicDeviceIcon}
                selectedDevices={selectedDevices}
                toggleDevice={toggleDevice}
                calculateBounds={calculateBounds}
                setCalcZoom={setCalcZoom}
                filter={filter}
                setFilter={setFilter}
                selectedGroup={selectedGroup}
                setSelectedGroup={setSelectedGroup}
              />
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          margin: "0 0 20px 0",
          height: "100px",
        }}
      >
        <img
          src={appContext.fullscreenMap ? logoDark : logo}
          alt="logo"
          style={{
            height: "100%",
            zIndex: 100,
            marginLeft: appContext.fullscreenMap ? 50 : 0,
          }}
        />
        <h1
          style={{
            position: "absolute",
            zIndex: 100,
            left: "50%",
            transform: "translateX(-50%)",
            color: appContext.fullscreenMap ? "#1b3f62" : "white",
          }}
        >
          Public Info - Road Closures & Sirens
        </h1>
        <div
          style={{
            zIndex: 100,
          }}
        >
          <Login triggerOpen={loginTrigger} />
        </div>
      </div>

      {/* Map and sidebar */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100%",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <FullScreenMap
          key={appContext.fullscreenMap}
          container={
            appContext.fullscreenMap
              ? { position: "absolute", top: 0, left: 0 }
              : {}
          }
          mapCenter={_initialMapCenter}
          zoom={_initialMapZoom}
          minZoom={6}
          maxZoom={18}
          onZoomEnd={(zoom) => {
            if (shouldResetFilter) {
              setSelectedGroup(null); // Reset selected group on zoom end
              setMultipleGroupsCollapse(
                Object.keys(collapsedGroups).reduce((acc, key) => {
                  acc[key] = true; // Collapse all groups
                  return acc;
                }, {})
              );
            }
            setCalcZoom(zoom);
          }}
          onMoveEnd={(center) => {
            setCalcCenter(center);
            // setSelectedGroup(null);
          }}
          onFullscreen={() => {
            appContext.setFullscreenMap(!appContext.fullscreenMap);
          }}
          fullscreen={appContext.fullscreenMap}
          setShowMobileDevices={setShowMobileDevices}
          onDragEnd={(center) => {
            setCalcCenter(center);
            // setSelectedGroup(null); // Reset selected group on drag end
          }}
          setCalcZoom={setCalcZoom}
          setCalcCenter={setCalcCenter}
          _initialMapCenter={_initialMapCenter}
          _initialMapZoom={_initialMapZoom}
          setMapZoom={setMapZoom}
          setMapCenter={setMapCenter}
        >
          <LocationSetter center={mapCenter} zoom={mapZoom} />
          {/* Replace displayData mapping with groupedDevices mapping */}
          {Object.keys(groupedDevices).map((category) =>
            groupedDevices[category].map((group) => (
              <DeviceMarker
                key={`${category}-${group.id}`}
                group={group}
                category={category}
                mapZoom={mapZoom}
                calcZoom={calcZoom}
                deviceTypeToCategory={deviceTypeToCategory}
                auth={{ auth: { email: "desktop" } }}
                triggerLoginOpen={triggerLoginOpen}
                setMapCenter={setMapCenter}
                setMapZoom={setMapZoom}
                setCalcZoom={setCalcZoom}
                popupOpen={popupOpen}
                setPopupOpen={setPopupOpen}
                listSelect={listSelect}
                selectedDevices={selectedDevices}
                toggleDevice={toggleDevice}
                saveSuccess={saveSuccess}
                handleSave={handleSave}
                setLoginPopupOpen={setLoginPopupOpen}
                collapsedGroups={collapsedGroups}
                toggleGroupCollapse={toggleGroupCollapse}
                calculateBounds={calculateBounds}
                groupedDevices={groupedDevices}
                setMultipleGroupsCollapse={setMultipleGroupsCollapse}
                setShowMobileDevices={
                  appContext.fullscreenMap ? setShowMobileDevices : undefined
                }
                filter={filter}
                setFilter={setFilter}
                setSelectedGroup={setSelectedGroup}
                selectedGroup={selectedGroup}
                setShouldResetFilter={setShouldResetFilter}
              />
            ))
          )}
        </FullScreenMap>

        {/* Sidebar device list */}
        {!appContext.fullscreenMap && (
          <div
            style={{
              width: "500px",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
            }}
          >
            <DeviceList
              showSettingsState={showSettingsState}
              setShowSettingsState={setShowSettingsState}
              setLoginPopupOpen={setLoginPopupOpen}
              triggerLoginOpen={triggerLoginOpen}
              handleSave={handleSave}
                saveSuccess={saveSuccess}
              groupedDevices={groupedDevices}
              toggleCategoryCollapse={toggleCategoryCollapse}
              collapsedCategories={collapsedCategories}
              toggleGroupCollapse={toggleGroupCollapse}
              collapsedGroups={collapsedGroups}
              listSelect={listSelect}
              setListSelect={setListSelect}
              setMapCenter={setMapCenter}
              setMapZoom={setMapZoom}
              getBasicDeviceIcon={getBasicDeviceIcon}
              selectedDevices={selectedDevices}
              toggleDevice={toggleDevice}
              calculateBounds={calculateBounds}
              setCalcZoom={setCalcZoom}
              filter={filter}
              setFilter={setFilter}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
            />
          </div>
        )}
      </div>

      {/* Modals */}
      <TermsOfUseModal
        showTermsOfUse={showTermsOfUse}
        setShowTermsOfUse={setShowTermsOfUse}
      />

      <PrivacyPolicyModal
        showPrivacyPolicy={showPrivacyPolicy}
        setShowPrivacyPolicy={setShowPrivacyPolicy}
      />

      {/* Bottom section */}
      <div
        style={{
          height: 100,
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <PolicyButtons
          setShowTermsOfUse={setShowTermsOfUse}
          setShowPrivacyPolicy={setShowPrivacyPolicy}
        />
        <div
          style={{
            marginLeft: 10,
          }}
        >
          <InfoButton />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default DesktopView;
